// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Rwanda */
const RW = /^(?:7[237-9]\d{7})$/;

export default RW;
